"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _OrdersListContainer = _interopRequireDefault(require("./OrdersListContainer"));
var _path = _interopRequireDefault(require("../../helpers/path"));
var _APIcon = _interopRequireDefault(require("../common/APIcon/APIcon"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./OrdersListLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('order-list-layout');
var OrdersListsLayout = function OrdersListsLayout(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('header')
  }, t('Orders')), /*#__PURE__*/_react["default"].createElement(_OrdersListContainer["default"], {
    ordersCount: props.ordersCount,
    filterBySelectedProduct: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('link-container')
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: bemClasses('view-more-link'),
    to: (0, _path["default"])(props.activityPath)
  }, t('View More Orders'), " ", /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "arrowNext",
    customClass: bemClasses('icon')
  }))));
};
var _default = exports["default"] = OrdersListsLayout;